import React, { PureComponent } from 'react'
import { connect } from "react-redux"


import * as actions from '../../store/actions/actions'

import "./user.css";
import Header from "../../components/Headers/Header";
import {Card,Button, CardHeader,CardBody, Container, FormGroup, Input, Row} from "reactstrap";
import {FormControl} from "react-bootstrap";
import Col from "react-bootstrap/Col";
import * as Roles from "../../store/actions/roles"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import "react-toggle/style.css"
import italianUserCreateTranslations from "../../translations/user/create/it.user.create.json";
import englishUserCreateTranslations from "../../translations/user/create/en.user.create.json";
import {CREATE_USER_REPORT_SECTION_FIELD_CHANGE} from "../../store/actions/actions";

class UserCreate extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianUserCreateTranslations, "it");
    this.props.addTranslationForLanguage(englishUserCreateTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchCorporates()
    this.props.fetchRoles()
    this.props.fetchBanks()
    this.props.checkBankAdminCorporate()
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    this.props.saveUser(this.props.userToCreate)
  }

  render() {

    let corporateError ="";
    let bankError ="";
    let errors="";
    errors=this.props.validationError;
    let nameError = ""
    let userNameError=""
    let emailError=""
    let passwordError=[]
    let passwordErrorCount=0;
    let roleError = "";
    let phoneError = "";
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'fullName')
            nameError=item.defaultMessage;
          if(item.field === 'username')
            userNameError=item.defaultMessage;
          if(item.field === 'email')
            emailError=item.defaultMessage;
          if(item.field === 'role')
            roleError=item.defaultMessage;
          if(item.field === 'idBank')
            bankError=item.defaultMessage;
          if(item.field === 'password')
            if(passwordErrorCount === 0){
              passwordError.push(item.defaultMessage)
              // passwordError=item.defaultMessage;
              passwordErrorCount+=1
            }else if(passwordErrorCount > 0){
              passwordError.push(item.defaultMessage)
              // passwordError=passwordError+ " \n " +item.defaultMessage
              passwordErrorCount+=1;
            }

          if(item.field === 'role')
            roleError=item.defaultMessage;
          if(item.field === 'phone')
            phoneError=item.defaultMessage;
          return ""
        });
      }
    }

    let distintaSection =  this.props.authenticatedUserRole !== Roles.BANK_SUPER_ADMIN ? null :
        <FormGroup>
          <label className="form-control-label" htmlFor="distinteSection">
            <Translate id="user.create.distinteSection"/>
          </label>
          <br></br>
          <input type="checkbox"
                 disabled={this.checkDistinteSection()}
                 value={this.props.distinteSection}
                 checked={ this.props.distinteSection }
                 onChange={(event) => this.onDistinteSectionChange(event.target.checked) } />
        </FormGroup>

    let role = this.props.authenticatedUserRole;
    let hasBankAdminCorporateCreated=this.props.hasBankAdminCorporateValue;
    let userToCreateRole = this.props.role;
    let corporateDisabled=Roles.checkDisabled(userToCreateRole,Roles.MODULE_CORPORATE);
    let corporateRequired=Roles.checkRequired(userToCreateRole,Roles.MODULE_CORPORATE);
    let bankDisabled=Roles.checkDisabled(userToCreateRole,Roles.MODULE_BANK)
    let bankRequired=Roles.checkRequired(userToCreateRole,Roles.MODULE_BANK)
    let bankOptions = ""
    let corporateOptions=""

    if(role === Roles.PAYDO_ADMIN){
      bankOptions=<FormControl className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' } as="select"
                               disabled={bankDisabled}
                               required={bankRequired}
                               onChange={(newValue) => {
        this.onIdBankChange(newValue.target.value);
      }}>
        <option></option>
        {this.props.banks.map((item)=>{
          return <option value={item.bankId+":"+item.bankName}>{item.bankName}</option>
        })}
      </FormControl>

      corporateOptions=<FormControl as="select"
                                    disabled={corporateDisabled}
                                    required={corporateRequired}
                                    onChange={(newValue) => {
                                      this.onCorporateSenderIdChange(newValue.target.value);
                                    }}
      >
        <option></option>
        {this.props.corporates.map((item)=>{
          if(this.props.idBank === item.bank){
            return <option value={item.corporateSenderId+":"+item.corporateSenderName}
                           disabled={!item.enabled}>{item.corporateSenderName}</option>
          }else{
            return <option style={{background:"gray"}} value={item.corporateSenderId+":"+item.corporateSenderName}
                           disabled={!item.enabled}>{item.corporateSenderName}</option>
          }
        })}
      </FormControl>
    }else if(role === Roles.PAYDO_MANAGER){
      bankOptions=<FormControl className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' } as="select"
                               disabled={bankDisabled}
                               required={bankRequired}
                               onChange={(newValue) => {
                                 this.onIdBankChange(newValue.target.value);
                               }}>
        <option></option>
        {this.props.banks.map((item)=>{
          return <option value={item.bankId+":"+item.bankName}>{item.bankName}</option>
        })}

      </FormControl>
      corporateOptions=
          <Translate>
            {({ translate }) =>
                <Input
                    disabled="disabled"
                    className="form-control-alternative"
                    // value={}
                    // onChange={this.onCorporateSenderIdChange}
                    id="corporateSenderId"
                    placeholder={translate("user.create.corporate")}
                    type="text"/>}
          </Translate>
    }else if(role === Roles.BANK_ADMIN || role === Roles.BANK_SUPER_ADMIN ||role === Roles.BANK_CORPORATE_ADMIN){
      let userBankId=this.props.userIdBank;
      this.onIdBankChange(userBankId);
      let bankName=this.props.banks.map((item) => {
        if(userBankId === item.bankId){
          return item.bankName;
        }
        return ""
      })
      bankOptions =
        <Translate>
        {({ translate }) =>
          <Input
          disabled="disabled"
          className="form-control-alternative"
          value={bankName}
          // onChange={this.onCorporateSenderIdChange}
          id="corporateSenderId"
          placeholder={translate("user.create.bank")}
          type="text"/>}
        </Translate>

      corporateOptions=<FormControl as="select"
                                    disabled={corporateDisabled}
                                    required={corporateRequired}
                                    onChange={(newValue) => {
                                      this.onCorporateSenderIdChange(newValue.target.value);
                                    }}
      >
        <option></option>
        {this.props.corporates.map((item)=>{

          if(hasBankAdminCorporateCreated.corporateExist === true
              && ((userToCreateRole !== null || userToCreateRole !== undefined || userToCreateRole !== '')
                  && (userToCreateRole === Roles.BANK_OPERATOR || userToCreateRole === Roles.BANK_AUTHORIZER))) {
            // hasBankAdminCorporateCreated.corporates.map((corporateId)=>{

            if(hasBankAdminCorporateCreated.corporates.indexOf(item.corporateSenderId) > -1){

              return <option disabled={!item.enabled} value={item.corporateSenderId+":"+item.corporateSenderName}>{item.corporateSenderName}</option>
            }else{

              return <option style={{background:"gray"}} disabled={true} value={item.corporateSenderId+":"+item.corporateSenderName}>{item.corporateSenderName}</option>
            }
          // })
          }else{

            return <option disabled={!item.enabled} value={item.corporateSenderId+":"+item.corporateSenderName}>{item.corporateSenderName}</option>
          }

        })}
      </FormControl>
    }else if(role === Roles.CORPORATE_ADMIN){
      let userBankId=this.props.userIdBank;
      this.onIdBankChange(userBankId);
      let bankName=this.props.banks.map((item)=>{
        if(userBankId === item.bankId){
          return item.bankName;
        }
        return ""
      })
      bankOptions =
        <Translate>
          {({ translate }) =>
            <Input
          disabled="disabled"
          className="form-control-alternative"
          value={bankName}
          // onChange={this.onCorporateSenderIdChange}
          id="corporateSenderId"
          placeholder={translate("user.create.bank")}
          type="text"/>}
        </Translate>

      let corporateId=this.props.authenticatedUserCorporateSenderId;
      this.onCorporateSenderIdChange(corporateId);
      let corporateName=this.props.corporates.map((item) => {
        if(corporateId === item.corporateSenderId){
          return item.corporateSenderName;
        }
        return ""
      })

      corporateOptions=
        <Translate>
          {({ translate }) =>
            <Input
          disabled="disabled"
          className="form-control-alternative"
          value={corporateName}
          // onChange={this.onCorporateSenderIdChange}
          id="corporateSenderId"
          placeholder={translate("user.create.corporate")}
          type="text"/>}
        </Translate>
    }
    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="user.create.title"/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="fullName">
                                <Translate id="user.create.name"/>
                              </label>
                              <div>
                                <Translate>
                                  {({ translate }) =>
                                    <Input
                                    className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                    value={this.props.fullName}
                                    onChange={this.onFullNameChange}
                                    id="fullName"
                                    placeholder={translate("user.create.name")}
                                    type="text"/>}
                                </Translate>
                              </div>
                              { nameError.length > 0 ? <label style={{color:"red"}}><Translate id={nameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.userName"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={userNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.username}
                                  onChange={this.onUsernameChange}
                                  id="username"
                                  placeholder={translate("user.create.userName")}
                                  type="text"/>}
                              </Translate>
                              { userNameError.length > 0 ? <label style={{color:"red"}}><Translate id={userNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.password"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={passwordError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.password}
                                  onChange={this.onPasswordChange}
                                  id="password"
                                  placeholder={translate("user.create.password")}
                                  type="text"/>}
                              </Translate>
                              { passwordError.length > 0 ? <label style={{color:"red"}}>

                                {passwordError.map((item)=>{
                                  return <span>
                                    <Translate id={item}/>
                                    <br></br>
                                  </span>
                                })}

                              </label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.phone"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  value={this.props.phone}
                                  onChange={this.onPhoneChange}
                                  id="phone"
                                  placeholder={translate("user.create.phone")}
                                  type="text"/>}
                              </Translate>
                              { phoneError.length > 0 ? <label style={{color:"red"}}><Translate id={phoneError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.email"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={emailError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.email}
                                  onChange={this.onEmailChange}
                                  id="email"
                                  placeholder={translate("user.create.email")}
                                  type="text"/>}
                              </Translate>
                              { emailError.length > 0 ? <label style={{color:"red"}}><Translate id={emailError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.description"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  value={this.props.description}
                                  onChange={this.onDescriptionChange}
                                  id="description"
                                  placeholder={translate("user.create.description")}
                                  type="text"/>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="language">
                                <Translate id="user.create.language"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <FormControl as="select"
                                               onChange={(newValue) => {
                                                 this.props.onLanguagePreferenceChange(newValue.target.value);
                                               }}>
                                    <option></option>
                                    {this.props.languages.map((item)=>{
                                      return <option value={item.code}>{translate(item.code)}</option>
                                    })}
                                  </FormControl>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="reportSection">
                                <Translate id="user.create.reportSection"/>
                              </label>
                              <br></br>
                              <input type="checkbox"
                                     value={this.props.reportSection}
                                     checked={ this.props.reportSection }
                                     onChange={ (event) => this.onReportSectionChange(event.target.checked)} />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            {distintaSection}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.role"/>
                              </label>
                              <FormControl className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' } as="select" onChange={(newValue) => {
                                this.onRoleChange(newValue.target.value);
                              }}>
                                <option></option>
                                {this.props.roles.map((item)=>{
                                  if(role === Roles.BANK_SUPER_ADMIN){
                                      if(hasBankAdminCorporateCreated.corporateExist === false){
                                          if(item.value === Roles.BANK_AUTHORIZER ||item.value === Roles.BANK_OPERATOR){
                                              return <option style={{background:"gray"}} value={item.value} disabled={true}>{item.value}</option>
                                          }else{
                                              return <option value={item.value}>{item.value}</option>
                                          }
                                      }else{
                                          return <option value={item.value}>{item.value}</option>
                                      }
                                  }
                                  else{
                                    return <option value={item.value}>{item.value}</option>
                                  }

                                })}
                              </FormControl>
                              { roleError.length > 0 ? <label style={{color:"red"}}><Translate id={roleError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="user.create.bank"/>
                              </label>
                              {bankOptions}
                              { bankError.length > 0 ? <label style={{color:"red"}}><Translate id={bankError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          {corporateRequired === false ? '' :
                              <Col lg="6">
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="username">
                                    <Translate id="user.create.corporate"/>
                                  </label>
                                  {corporateOptions}
                                </FormGroup>
                              </Col>
                          }
                        </Row>
                        <Row>
                          <Col align={"left"}>
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align={"right"}>
                            <Button className="btn-success" type="submit" variant="contained" >
                              <Translate id="user.create.save.button"/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }

  onIdBankChange = (idBank) => {
    if(idBank !== '')
      this.props.idBankChange(idBank)
  }

  onCorporateSenderIdChange = (corporateSenderId) => {
    if(corporateSenderId !== '')
      this.props.corporateSenderIdChange(corporateSenderId)
  }

  onRoleChange = (role) => {
    if(role !== 'undefined')
      this.props.roleChange(role)
    if(role === Roles.PAYDO_ADMIN){
      this.props.idBankChange("")
      this.props.corporateSenderIdChange("")
    }else if(role === Roles.BANK_ADMIN || role === Roles.BANK_CORPORATE_AUTHORIZER || role === Roles.BANK_CORPORATE_ADMIN){
      this.props.corporateSenderIdChange("")
    }
    this.checkDistinteSection()
  }

  checkDistinteSection() {
    if (this.props.authenticatedUserRole === Roles.BANK_SUPER_ADMIN) {
      if (this.props.role === Roles.BANK_ADMIN || this.props.role === Roles.BANK_CORPORATE_ADMIN) {
        return false;
      }
    }
    return true;
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }

  onFullNameChange = (event) => {
    let fullName = event.target.value
    this.props.fullNameChange(fullName)
  }

  onDescriptionChange = (event) => {
    let description = event.target.value
    this.props.descriptionChange(description)
  }

  onUsernameChange = (event) => {
    let username = event.target.value
    this.props.usernameChange(username)
  }

  onPasswordChange = (event) => {
    let password = event.target.value
    this.props.passwordChange(password)
  }

  onPhoneChange = (event) => {
    let phone = event.target.value
    this.props.phoneChange(phone)
  }

  onEmailChange = (event) => {
    let email = event.target.value
    this.props.emailChange(email)
  }

  onResetChange = (event) => {
    let reset = event.target.value === "true" ? true : false
    this.props.resetChange(reset)
  }

  onReportSectionChange = (reportSection) => {
    if (reportSection === true) {
      this.props.reportSectionChange(true)
    } else if (reportSection === false) {
      this.props.reportSectionChange(false)
    }
  }

  onDistinteSectionChange = (distinteSection) => {
    if (distinteSection === true) {
      this.props.distinteSectionChange(true)
    } else if (distinteSection === false) {
      this.props.distinteSectionChange(false)
    }
  }
}

const mapStateToProps = state => {
  return {
    userToCreate: state.userCreate.userToCreate,
    idBank: state.userCreate.userToCreate.idBank,
    corporateSenderId: state.userCreate.userToCreate.corporateSenderId,
    fullName: state.userCreate.userToCreate.fullName,
    description: state.userCreate.userToCreate.description,
    enabled: state.userCreate.userToCreate.enabled === true ? "true" : "false",
    username: state.userCreate.userToCreate.username,
    password: state.userCreate.userToCreate.password,
    phone: state.userCreate.userToCreate.phone,
    email: state.userCreate.userToCreate.email,
    reset: state.userCreate.userToCreate.reset === true ? "true" : "false",
    role: state.userCreate.userToCreate.role,
    reportSection: state.userCreate.userToCreate.reportSection,
    distinteSection: state.userCreate.userToCreate.distinteSection,
    hasBankAdminCorporateValue: state.userCreate.hasBankAdminCorporate,
    roles: state.role.roles,
    banks: state.bank.banks,
    corporates: state.corporate.corporates,
    authenticatedUserRole: state.authentication.authenticatedUser.role,
    userIdBank:state.authentication.authenticatedUser.idBank,
    authenticatedUserCorporateSenderId:state.authentication.authenticatedUser.corporateSenderId,
    validationError:state.userCreate.error,
    languages: state.localize.languages
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveUser: (user) => dispatch({ type: actions.SAVE_USER_CREATE_REQUEST, value: user }),
    idBankChange: (idBank) => dispatch({ type: actions.CREATE_USER_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank }),
    corporateSenderIdChange: (corporateSenderId) => dispatch({ type: actions.CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST, value: corporateSenderId }),
    fullNameChange: (fullName) => dispatch({ type: actions.CREATE_USER_FULL_NAME_FIELD_CHANGE_REQUEST, value: fullName }),
    descriptionChange: (description) => dispatch({ type: actions.CREATE_USER_DESCRIPTION_FIELD_CHANGE_REQUEST, value: description }),
    enabledChange: (enabled) => dispatch({ type: actions.CREATE_USER_ENABLED_FIELD_CHANGE_REQUEST, value: enabled }),
    usernameChange: (username) => dispatch({ type: actions.CREATE_USER_USERNAME_FIELD_CHANGE_REQUEST, value: username }),
    passwordChange: (password) => dispatch({ type: actions.CREATE_USER_PASSWORD_FIELD_CHANGE_REQUEST, value: password }),
    phoneChange: (phone) => dispatch({ type: actions.CREATE_USER_PHONE_FIELD_CHANGE_REQUEST, value: phone }),
    emailChange: (email) => dispatch({ type: actions.CREATE_USER_EMAIL_FIELD_CHANGE_REQUEST, value: email }),
    resetChange: (reset) => dispatch({ type: actions.CREATE_USER_RESET_FIELD_CHANGE_REQUEST, value: reset }),
    reportSectionChange: (reportSection) => dispatch({ type: actions.CREATE_USER_REPORT_SECTION_FIELD_CHANGE, value: reportSection }),
    distinteSectionChange: (distinteSection) => dispatch({ type: actions.CREATE_USER_DISTINTE_SECTION_FIELD_CHANGE, value: distinteSection }),
    roleChange: (role) => dispatch({ type: actions.CREATE_USER_ROLE_FIELD_CHANGE_REQUEST, value: role }),
    fetchRoles: () => dispatch({ type: actions.FETCH_ROLES_REQUEST }),
    fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
    checkBankAdminCorporate:() => dispatch({ type: actions.CHECK_BANK_ADMIN_CORPORATE_REQUEST }),
    onLanguagePreferenceChange: (language) => dispatch({ type: actions.CREATE_USER_LANGUAGE_FIELD_CHANGE_REQUEST, value: language }),
  };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(UserCreate));